<template>
  <div class="wangEditor" ref="editor"></div>
</template>

<script>
import {
  onMounted,
  onBeforeUnmount,
  ref,
  reactive,
  watch,
  inject,
  getCurrentInstance,
} from "vue";
import WangEditor from "wangeditor";
import api from "../api";
import utils from "../utils/utils";

export default {
  name: "app",
  props: {
    height: {
      default: 400,
    },
    html: {},
  },
  setup(props, ctx) {
    const editor = ref();
    const content = reactive({
      html: "",
      text: "",
    });

    const internalInstance = getCurrentInstance();

    const app = internalInstance.appContext.config.globalProperties;
    let instance;
    onMounted(() => {
      instance = new WangEditor(editor.value);

      // 菜单
      instance.config.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        // "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        // "video", // 插入视频
        // "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen", // 全屏
      ];

      Object.assign(instance.config, {
        onchange(html) {
          ctx.emit("change", html);
          ctx.emit("input", html);
        },
      });

      instance.config.customUploadImg = async (files, insert) => {
        /* files 是 input 中选中的文件列表 */
        const file = files[0];
        files.forEach(async (item) => {
          app.$api
            .uploadFile("2", item)
            .then((res) => {
              insert(app.$utils.fileUrl(res));
            })
            .catch(() => {});
        });
      };

      instance.config.zIndex = 500;
      instance.create();
    });

    onBeforeUnmount(() => {
      instance.destroy();
      instance = null;
    });

    const syncHTML = () => {
      content.html = instance.txt.html();
    };
    const clear = () => {
      //   content.txt.clear();
      instance.txt.html("");
    };
    const data = reactive({
      status: false,
    });
    watch(
      () => props.html,
      (val, old) => {
        if (!data.status) {
          instance.txt.html(props.html);
          data.status = true;
        }
        // if (typeof props.html === 'string') {
        //   instance.txt.html(props.html);
        // }
        // instance.selection.moveCursor(instance.$textElem.elems[0], false);
        // if (!val) {
        //   instance.txt.clear();
        // }
      }
    );

    return {
      syncHTML,
      editor,
      content,
      clear,
    };
  },
};
</script>
